module.exports = __webpack_public_path__ + "static/media/play-stone-boss-3-active.cc1a3f82.png";